import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon_input_clear_plain.svg'
import _imports_1 from '@/assets/icons/icon_set_password.svg'
import _imports_2 from '@/assets/icons/icon_layout_eye.svg'
import _imports_3 from '@/assets/icons/icon_layout_password.svg'
import _imports_4 from '@/assets/icons/icon_plus_new.svg'
import _imports_5 from '@/assets/images/layout/big_app_logo.png'
import _imports_6 from '@/assets/images/layout/edit_password_success.png'
import _imports_7 from '@/assets/images/layout/edit_password_fail.png'


const _hoisted_1 = { class: "email-address-input-cont" }
const _hoisted_2 = { class: "next-btn-cont" }
const _hoisted_3 = { class: "term-of-privacy" }
const _hoisted_4 = { class: "verify-identity-cont" }
const _hoisted_5 = { class: "verify-identity-icon" }
const _hoisted_6 = { class: "has-sended-message" }
const _hoisted_7 = { class: "account-message-input-cont" }
const _hoisted_8 = {
  key: 0,
  src: _imports_2
}
const _hoisted_9 = {
  key: 1,
  src: _imports_3
}
const _hoisted_10 = {
  key: 0,
  src: _imports_2
}
const _hoisted_11 = {
  key: 1,
  src: _imports_3
}
const _hoisted_12 = { class: "create-account-btn-cont" }
const _hoisted_13 = { class: "complete-personal-information" }
const _hoisted_14 = { class: "personal-base-info" }
const _hoisted_15 = { class: "personal-upload-avator" }
const _hoisted_16 = { class: "avatar-upload-cont" }
const _hoisted_17 = {
  key: 0,
  class: "profile-thumb"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "btn-upload br8" }
const _hoisted_20 = { class: "personal-preference-procedure" }
const _hoisted_21 = { class: "procedure-list-cont" }
const _hoisted_22 = { class: "procedure-list-wrapper" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "img-cont" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "procedure-text" }
const _hoisted_27 = { class: "btn-cont" }
const _hoisted_28 = { class: "line" }
const _hoisted_29 = { class: "text" }
const _hoisted_30 = { class: "register-done" }
const _hoisted_31 = { class: "verify-success verify-step-container" }
const _hoisted_32 = { class: "describe" }
const _hoisted_33 = { class: "back-to-login-btn-cont" }
const _hoisted_34 = { class: "verify-fail verify-step-container" }
const _hoisted_35 = { class: "back-to-login-btn-cont return-btn-cont" }

import {
    NForm,
    NFormItem,
    NInput,
    NButton,
    NRadioGroup,
    NRadio,
    NIcon,
    NScrollbar,
    NProgress, 
    NUpload,
    NCheckbox,
    NModal,
} from "naive-ui";
import type { FormInst, FormItemRule, FormRules, UploadCustomRequestOptions } from "naive-ui";
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
// import ChoseUserIdentify from "./ChoseUserIdentify.vue";
import {
    GenderTypeList,
    REQUEST_SCCUESS_CODE,
    USER_INDENTIFY_KEY,
    UserRole,
    SourceType,
    MAX_FILE_SIZE,
    VUE_APP_IMG_BUCKET_NAME,
} from "@/constant";
import {
    validateEmail,
    validatePassword,
    validateUserName,
} from "@/utils/util";
import { useStore } from "vuex";
import type {
    FormItemThemeOverrides,
} from "@/types/themeOverrides";
import DateSelect from "@/components/DateSelect.vue";
import { useRegisterAct } from "@/composables/useRegisterAct";
import { useInterestedList } from "@/composables/useInterestedList";
import { useNavigatorSystem } from "@/composables/useNaviSystem";
import storage from "@/utils/storage";
import { useRouter } from "vue-router";
import { uploadImgToS3 } from "@/utils/s3-client";
import PrivacyPolicyContent from "@/views/other/modalModules/PrivacyPolicyContent.vue"
import TermsServiceContent from "@/views/other/modalModules/TermsServiceContent.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterMain',
  props: {
    currentStep: {
        type: Number,
        default: () => {
            return 1;
        },
    },
    curBaseInfoStep: {
        type: Number,
        default: () => {
            return 1;
        },
    },
},
  emits: [
    "update:currentStep",
    "onLogin",
    "onChangeuserInfoStep",
    "onClose",
],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const formItemThemeOverrides: FormItemThemeOverrides = {
    feedbackPadding: "12px 0",
};

const store = useStore();
const router = useRouter();
const {
    _clickVerifyEmailByApi,
    _userSetTheirProfileByApi,
    _isConfirmEmailByApi,
} = useRegisterAct();
const { curInterestedList, _initInterestedPage } = useInterestedList();
const { isMobile } = useNavigatorSystem();

const agreeAuthTermOfPrivacy = ref<boolean>(false);
const isShowPrivacyModal = ref<boolean>(false);
const isShowTermServiceModal = ref<boolean>(false);
const registerEmailFormRef = ref<FormInst | null>(null);
const createAccountStep = ref<number>(1);
const genderOtpsList = ref(GenderTypeList);
const showRegisterPassword = ref<boolean>(false);
const showRegisterConfirmPassword = ref<boolean>(false);
const registerEmail = ref<any>({
    email: "",
});
const registerEmailRules: FormRules = {
    email: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validateEmail(value)) {
                    return new Error("Please enter a valid email address");
                }
                return true;
            },
        },
    ],
};
const cacheUserRole = ref<string>("USER");

const isDoctorRole = computed(() => {
    return cacheUserRole.value === UserRole.Doctor ? true : false;
})

const userNamePlaceholder = computed(() => {
    return isDoctorRole.value ? `Enter your legal name as it appears on the AHPRA register` : `Enter Your User Name`
})

const showRegisterEmailClearBtn = computed(() => {
    return registerEmail.value.email ? true : false;
});

const isDisabledRegisterEmailBtn = computed(() => {
    return registerEmail.value.email ? false : true;
});

const registerFormRef = ref<FormInst | null>(null);
const registerMessageModel = ref<any>({
    nickname: null,
    password: null,
    confirmPassword: null,
});

const showRegisterUserNameClearBtn = computed(() => {
    return registerMessageModel.value.nickname ? true : false;
});

const showRegisterPasswordClearBtn = computed(() => {
    return registerMessageModel.value.password ? true : false;
});

const showRegisterConfirmPasswordClearBtn = computed(() => {
    return registerMessageModel.value.confirmPassword ? true : false;
});

const isDisabledCreateAccount = computed(() => {
    return registerMessageModel.value.nickname &&
        registerMessageModel.value.password &&
        registerMessageModel.value.confirmPassword
        ? false
        : true;
});

const registerMessageModelRules: FormRules = {
    nickname: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validateUserName(value)) {
                    return new Error("user name must least 5~50 letters");
                }
                return true;
            },
        },
    ],
    password: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validatePassword(value)) {
                    return new Error("password must 6~25 letters, at least one special character or one uppercase letter");
                }
                return true;
            },
        },
    ],
    confirmPassword: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validatePassword(value)) {
                    return new Error("password must 6~25 letters, at least one special character or one uppercase letter");
                }
                return true;
            },
        },
    ],
};

const curCompletePersonalInformationStep = ref<number>(1);
const completePersonalInformationFormRef = ref<FormInst | null>(null);
const completePersonalInformationModel = ref<any>({
    gender: "0",
    userName: null,
    birthday: null,
    procedureSelected: [],
    avatar: null
});

const uploadRef = ref<any>(null);
const currentUploadedFile = ref<any>(null);
const isLoadingFile = ref<boolean>(false);
const isLoadedSuccess = ref<boolean>(false);

const isDisabledUserMemberPublish = computed(() => {
    return completePersonalInformationModel.value.userName ||
        completePersonalInformationModel.value.procedureSelected
        ? false
        : true;
});
const completePersonalInformationModelRules: FormRules = {
    gender: [
        {
            required: false,
        },
    ],
    userName: [
        {
            required: false,
        },
    ],
    avatar: [
        {
            required: false,
        },
    ],
    procedureSelected: [
        {
            required: false,
        },
    ],
};

const onSelectBirthady = (date: { year: any; month: any; day: any }) => {
    const { year, month, day } = date;
    completePersonalInformationModel.value.birthday = `${year}-${month}-${day}`;
};

const _handleClearRegisterEmail = () => {
    registerEmail.value.email = "";
};

const _handleValidEmail = () => {
    if (isDisabledRegisterEmailBtn.value) {
        MessageAlert("Please input correct email");
        return;
    }
    //createAccountStep.value = 2;
    registerEmailFormRef.value?.validate(async (errors) => {
        if (!errors) {
            const params: any = {
                email: registerEmail.value.email,
                userRole: cacheUserRole.value,
                source: SourceType.Register
            };
            const res: any = await _clickVerifyEmailByApi(params);
            if (res?.code === REQUEST_SCCUESS_CODE) {
                //下一步
                createAccountStep.value = 2;
            } else {
                let errMess = res?.msg || "email verify failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please enter a valid email address";
            MessageAlert(errMess);
        }
    });
};

const _hanleResendEmail = () => {
    _handleValidEmail();
};

// const _hanleCheckVerify = async () => {
//     const params: any = {
//         email: registerEmail.value.email,
//         userRole: cacheUserRole.value,
//     };
//     //createAccountStep.value = 3;
//     const res: any = await _isConfirmEmailByApi(params);
//     if (res?.code === REQUEST_SCCUESS_CODE) {
//         //下一步
//         createAccountStep.value = 3;
//     } else {
//         let errMess = res?.msg || "email confirm failed";
//         MessageAlert(errMess);
//     }
// };

const _handleClearRegisterUserName = () => {
    registerMessageModel.value.nickname = "";
};

const _handleClearRegisterPassword = () => {
    registerMessageModel.value.password = "";
};

const _handleClearRegisterConfirmPassword = () => {
    registerMessageModel.value.confirmPassword = "";
};

const _handleShowRegisterPassword = () => {
    showRegisterPassword.value = !showRegisterPassword.value;
};

const _handleShowRegisterConfirmPassword = () => {
    showRegisterConfirmPassword.value = !showRegisterConfirmPassword.value;
};

const updateCreateAccountStep = (step: number) => {
    emits("update:currentStep", step);
};

const updateCompleteInfoStep = (step: number) => {
    emits("onChangeuserInfoStep", step);
};

const _handleCreateAccount = () => {
    if (isDisabledCreateAccount.value) {
        MessageAlert("Please enter");
        return;
    }
    if (
        registerMessageModel.value.password !==
        registerMessageModel.value.confirmPassword
    ) {
        MessageAlert("confirmPassword must be consistent");
        return;
    }
    //createAccountStep.value = 4;
    registerFormRef.value?.validate((errors) => {
        if (!errors) {
            try {
                const userType = storage.get(USER_INDENTIFY_KEY) || 1;
                const params = {
                    email: registerEmail.value.email,
                    nickname: registerMessageModel.value.nickname,
                    password: registerMessageModel.value.password,
                    userRole:
                        Number(userType) === 1
                            ? UserRole.User
                            : UserRole.Doctor,
                };
                store.dispatch("user/userRegisterEmail", params).then((res:any)=>{
                    console.log("user/userRegisterEmail========>>>>>", res)
                    createAccountStep.value = 4;
                }).catch((error: any) => {
                    console.error("user/userRegisterEmail========>>>>>", error)
                });
            } catch (error: any) {
                const errMess = error?.message || "register failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please enter a valid email address";
            MessageAlert(errMess);
        }
    });
};

watch(
    () => props.currentStep,
    (newV) => {
        createAccountStep.value = newV;
    },
    { immediate: true }
);

watch(
    () => createAccountStep.value,
    (newV) => {
        updateCreateAccountStep(newV);
    },
    { immediate: true }
);

watch(
    () => props.curBaseInfoStep,
    (newV) => {
        curCompletePersonalInformationStep.value = newV;
    },
    { immediate: true }
);

watch(
    () => curCompletePersonalInformationStep.value,
    (newV) => {
        updateCompleteInfoStep(newV);
    },
    { immediate: true }
);

// 注册-选择完职业之后点击next按钮
// const _handleChooseCareerNext = (type: number) => {
//     if (type === 1) {
//         createAccountStep.value = 4;
//     } else if (type === 2) {
//         createAccountStep.value = 6;
//     }
// };

// 读取选择的文件
const readFile = (file: any, cb: any) => {
    if (file?.success) {
        const curFile = file?.file;
        const reader = new FileReader();
        reader.readAsDataURL(curFile);
        reader.onload = (e) => {
            cb &&
                cb({
                    imgSrc: file?.location || e.target?.result,
                    file: file,
                });
        };
    } else {
        const errMess = "file upload failed";
        MessageAlert(errMess);
    }
};

const customRequest = async ({ file }: UploadCustomRequestOptions) => {
    //console.log("customRequest====why222222222222222===>", file);
    isLoadingFile.value = true;
    isLoadedSuccess.value = false;
    let curUploadFile = {
        id: file?.id,
        isLoadingFile: isLoadingFile.value,
        isLoadedSuccess: isLoadedSuccess.value,
        uploadFilePercentage: file?.percentage,
        imgSrc: "",
        fileType: file.type,
    };
    currentUploadedFile.value = { file: file, ...curUploadFile };
    const resp = await uploadImgToS3(
        {
            file: file?.file as File,
            maxFileSize: MAX_FILE_SIZE,
            bucketName: VUE_APP_IMG_BUCKET_NAME,
        },
        (progressEvent: any) => {
            const percentCompleted = Math.ceil(
                (progressEvent.loaded * 100) / progressEvent.total
            );
            //console.log("上传进度：" + percentCompleted + "%", file);
            currentUploadedFile.value.uploadFilePercentage = percentCompleted;
        }
    );
    isLoadingFile.value = false;
    if (resp?.success) {
        isLoadedSuccess.value = true;
        const curImgSrc = resp?.location || "";
        currentUploadedFile.value.imgSrc = curImgSrc;
        currentUploadedFile.value.isLoadingFile = false;
        currentUploadedFile.value.isLoadedSuccess = true;
        currentUploadedFile.value.uploadFilePercentage = 100;
        
    } else {
        isLoadedSuccess.value = false;
        currentUploadedFile.value.imgSrc = "";
        currentUploadedFile.value.fileType = "";
        currentUploadedFile.value.isLoadingFile = false;
        currentUploadedFile.value.isLoadedSuccess = false;
        currentUploadedFile.value.uploadFilePercentage = 0;
        const errMess = "file upload failed";
        MessageAlert(errMess);
    }
    completePersonalInformationModel.value.avatar = currentUploadedFile.value?.imgSrc;
    uploadRef.value?.clear();
    //console.log("uploadImgToS3===>", resp);
};

//注册账号-完善个人信息时跳过
const skipCompletePersonalInformation = () => {
    if (curCompletePersonalInformationStep.value < 3) {
        curCompletePersonalInformationStep.value++;
    } else {
        createAccountStep.value++;
    }
};

const _handleShowLogin = () => {
    emits("onLogin");
    createAccountStep.value = 1;
};

const _handleGoToHomepagePage = () => {
    router.push({ path: "/" });
    nextTick(() => {
        emits("onClose");
    });
};

const _handleRefreshInterestedList = () => {
    _initInterestedPage();
};

const _hancleSelcetProcedureItem = (item: any) => {
    const findIdx =
        completePersonalInformationModel.value.procedureSelected.findIndex(
            (ele: any) => ele === item?.id
        );
    if (findIdx > -1) {
        completePersonalInformationModel.value.procedureSelected.splice(
            findIdx,
            1
        );
    } else {
        completePersonalInformationModel.value.procedureSelected.push(item?.id);
    }
};

const _goToPageDoctorProfile = () => {
    router.push({ path: "/user/profile", query: { from: "user" } });
    nextTick(() => {
        emits("onClose");
    });
    // if(isMobile.value){
    //     router.push({ path: "/mobile/user/profile", query: { from: "user" } });
    // }else{
    //     router.push({ path: "/user/profile", query: { from: "user" } });
    //     nextTick(() => {
    //         emits("onClose");
    //     });
    // }
};

const _handleGoToMyProfilePage = () => {
    _goToPageDoctorProfile();
};

const _handlePublish = () => {
    //createAccountStep.value = 6;
    completePersonalInformationFormRef.value?.validate(async (errors) => {
        if (!errors) {
            const params = {
                email: registerEmail.value.email,
                nickname: completePersonalInformationModel.value.userName,
                birthday: completePersonalInformationModel.value.birthday,
                gender: completePersonalInformationModel.value.gender,
                img: completePersonalInformationModel.value.avatar,
                interested:
                    completePersonalInformationModel.value.procedureSelected,
            };
            const res: any = await _userSetTheirProfileByApi(params);
            if (res?.code === REQUEST_SCCUESS_CODE) {
                createAccountStep.value = 6;
            } else {
                const errMess = res?.msg || "api failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please check errors";
            MessageAlert(errMess);
        }
    });
};

const handleShowPrivacyPolicy = () => {
    isShowPrivacyModal.value = true;
}
const _handleClosePrivacy = () => {
    isShowPrivacyModal.value = false;
}
const _handleConfirmPrivacy = () => {
    isShowPrivacyModal.value = false;
}
const _handleShowTermsOfService = () => {
    isShowTermServiceModal.value = true;
}
const _handleCloseTermService = () => {
    isShowTermServiceModal.value = false;
}
const _handleConfirmTermService = () => {
    isShowTermServiceModal.value = false;
}

const _initRegisterPage = () => {
    const cacheUserRoleLocal = store.getters["user/getUserRole"];
    cacheUserRole.value = cacheUserRoleLocal;

    const cacheUserThirdEmail = store.getters["user/getUserThirdEmail"];
    const loginEmail = store.getters["user/getLoginEmail"];
    registerEmail.value.email = loginEmail || cacheUserThirdEmail;
};

onMounted(() => {
    nextTick(() => {
        _initRegisterPage();
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["register-message-cont", { 'register-mobile-cont': _unref(isMobile) }])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NForm), {
        ref_key: "registerEmailFormRef",
        ref: registerEmailFormRef,
        model: registerEmail.value,
        rules: registerEmailRules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "email",
            label: "Email Address",
            "theme-overrides": formItemThemeOverrides
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                value: registerEmail.value.email,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((registerEmail.value.email) = $event)),
                placeholder: "Enter your Email Address",
                size: "large",
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, {
                suffix: _withCtx(() => [
                  _withDirectives(_createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "16",
                    onClick: _handleClearRegisterEmail
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, showRegisterEmailClearBtn.value]
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(NCheckbox), {
            checked: agreeAuthTermOfPrivacy.value,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((agreeAuthTermOfPrivacy).value = $event))
          }, null, 8, ["checked"]),
          _cache[17] || (_cache[17] = _createTextVNode(" By continuing, I agree that I am at least 18 years old and have read the ")),
          _createElementVNode("span", { onClick: _handleShowTermsOfService }, "terms of service"),
          _cache[18] || (_cache[18] = _createTextVNode(" and ")),
          _createElementVNode("span", { onClick: handleShowPrivacyPolicy }, "privacy policy"),
          _cache[19] || (_cache[19] = _createTextVNode(". "))
        ]),
        _createVNode(_unref(NButton), {
          color: 
                        !isDisabledRegisterEmailBtn.value
                            ? '#000000'
                            : 'rgba(0, 0, 0, 0.2)'
                    ,
          "text-color": "#ffffff",
          "icon-placement": "right",
          disabled: isDisabledRegisterEmailBtn.value,
          onClick: _handleValidEmail
        }, {
          default: _withCtx(() => [
            (isDisabledRegisterEmailBtn.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Next ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Verify ")
                ], 64))
          ]),
          _: 1
        }, 8, ["color", "disabled"])
      ]),
      _createElementVNode("div", { class: "tips-privacy-container" }, [
        _createElementVNode("div", { class: "log-in-tip" }, [
          _cache[20] || (_cache[20] = _createTextVNode(" Already have an account? ")),
          _createElementVNode("span", { onClick: _handleShowLogin }, "Log in")
        ])
      ])
    ], 512), [
      [_vShow, createAccountStep.value === 1]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(NIcon), { class: "setpassword-icon" }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createElementVNode("img", { src: _imports_1 }, null, -1)
          ])),
          _: 1
        })
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "verify-identity-title" }, [
        _createElementVNode("span", null, "Set Password")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[22] || (_cache[22] = _createTextVNode(" We have sent you an email to verify that your email address is ")),
        _createElementVNode("span", null, _toDisplayString(registerEmail.value.email), 1)
      ]),
      _createElementVNode("div", { class: "btn-group" }, [
        _createElementVNode("div", {
          class: "custom-btn resend-btn",
          onClick: _hanleResendEmail
        }, " Resend Verification Email ")
      ])
    ], 512), [
      [_vShow, createAccountStep.value === 2]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(NForm), {
        ref_key: "registerFormRef",
        ref: registerFormRef,
        model: registerMessageModel.value,
        rules: registerMessageModelRules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "nickname",
            label: "User Name",
            "theme-overrides": formItemThemeOverrides
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                value: registerMessageModel.value.nickname,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((registerMessageModel.value.nickname) = $event)),
                placeholder: userNamePlaceholder.value,
                size: "large",
                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, {
                suffix: _withCtx(() => [
                  _withDirectives(_createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "16",
                    onClick: _handleClearRegisterUserName
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, showRegisterUserNameClearBtn.value]
                  ])
                ]),
                _: 1
              }, 8, ["value", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), {
            path: "password",
            label: "Password",
            "theme-overrides": formItemThemeOverrides
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                value: registerMessageModel.value.password,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((registerMessageModel.value.password) = $event)),
                type: showRegisterPassword.value ? 'text' : 'password',
                placeholder: "Enter Your Password",
                size: "large",
                autocomplete: "",
                onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "24",
                    onClick: _handleShowRegisterPassword
                  }, {
                    default: _withCtx(() => [
                      (showRegisterPassword.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "16",
                    onClick: _handleClearRegisterPassword
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, showRegisterPasswordClearBtn.value]
                  ])
                ]),
                _: 1
              }, 8, ["value", "type"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), {
            path: "confirmPassword",
            label: "Re-enter your Password",
            "theme-overrides": formItemThemeOverrides
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                value: registerMessageModel.value.confirmPassword,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((registerMessageModel.value.confirmPassword) = $event)),
                type: 
                            showRegisterConfirmPassword.value ? 'text' : 'password'
                        ,
                placeholder: "Confirm Your Password",
                size: "large",
                onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "24",
                    onClick: _handleShowRegisterConfirmPassword
                  }, {
                    default: _withCtx(() => [
                      (showRegisterConfirmPassword.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", _hoisted_11))
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_unref(NIcon), {
                    class: "btn-icon",
                    size: "16",
                    onClick: _handleClearRegisterConfirmPassword
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, showRegisterConfirmPasswordClearBtn.value]
                  ])
                ]),
                _: 1
              }, 8, ["value", "type"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(NButton), {
          color: !isDisabledCreateAccount.value ? '#000000' : 'rgba(0, 0, 0, 0.2)',
          "text-color": "#ffffff",
          disabled: isDisabledCreateAccount.value,
          onClick: _handleCreateAccount
        }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode(" Create ")
          ])),
          _: 1
        }, 8, ["color", "disabled"])
      ])
    ], 512), [
      [_vShow, createAccountStep.value === 3]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createVNode(_unref(NForm), {
        ref_key: "completePersonalInformationFormRef",
        ref: completePersonalInformationFormRef,
        model: completePersonalInformationModel.value,
        rules: completePersonalInformationModelRules
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(NFormItem), { "theme-overrides": formItemThemeOverrides }, {
              default: _withCtx(() => [
                _createVNode(_unref(NRadioGroup), {
                  value: completePersonalInformationModel.value.gender,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((completePersonalInformationModel.value.gender) = $event)),
                  name: "radiogroup1"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(genderOtpsList.value, (rad) => {
                      return (_openBlock(), _createBlock(_unref(NRadio), {
                        key: rad.value,
                        value: rad.value,
                        size: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(rad.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              path: "userName",
              label: "Your Name",
              "theme-overrides": formItemThemeOverrides
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: 
                                completePersonalInformationModel.value.userName
                            ,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((
                                completePersonalInformationModel.value.userName
                            ) = $event)),
                  placeholder: "Enter Your Name",
                  size: "large",
                  onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              path: "birthday",
              label: "Birthday",
              "theme-overrides": formItemThemeOverrides
            }, {
              default: _withCtx(() => [
                _createVNode(DateSelect, {
                  value: completePersonalInformationModel.value.birthday,
                  onOnChange: onSelectBirthady
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, curCompletePersonalInformationStep.value === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(NFormItem), {
              path: "avatar",
              label: "Your Avatar",
              "theme-overrides": formItemThemeOverrides
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  (completePersonalInformationModel.value?.avatar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: completePersonalInformationModel.value?.avatar,
                          alt: "avatar"
                        }, null, 8, _hoisted_18),
                        _withDirectives(_createVNode(_unref(NProgress), {
                          type: "line",
                          height: 2,
                          percentage: currentUploadedFile.value?.uploadFilePercentage,
                          "show-indicator": false
                        }, null, 8, ["percentage"]), [
                          [_vShow, isLoadingFile.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(NUpload), {
                    ref_key: "uploadRef",
                    ref: uploadRef,
                    "custom-request": customRequest,
                    "show-file-list": false,
                    accept: "image/*"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_unref(NIcon), {
                          name: "action",
                          size: "24"
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createElementVNode("img", { src: _imports_4 }, null, -1)
                          ])),
                          _: 1
                        }),
                        _cache[29] || (_cache[29] = _createElementVNode("span", null, "Upload", -1))
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, curCompletePersonalInformationStep.value === 2]
          ])
        ]),
        _: 1
      }, 8, ["model"]),
      _withDirectives(_createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", { class: "refresh-procedure-tip" }, [
          _cache[30] || (_cache[30] = _createTextVNode(" Don’t like these? ")),
          _createElementVNode("span", {
            class: "btn-refresh",
            onClick: _handleRefreshInterestedList
          }, " Refresh ")
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_unref(NScrollbar), { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(curInterestedList), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["procedure-list-item", {
                                    selected:
                                        completePersonalInformationModel.value.procedureSelected.includes(
                                            item?.id
                                        ),
                                }]),
                    onClick: ($event: any) => (_hancleSelcetProcedureItem(item))
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("img", {
                        src: item.img
                      }, null, 8, _hoisted_25)
                    ]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(item?.name), 1)
                  ], 10, _hoisted_23))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, curCompletePersonalInformationStep.value === 3]
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_unref(NButton), {
          "text-color": "#000000",
          style: {"border":"1px solid #000000"},
          onClick: skipCompletePersonalInformation
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [
            _createTextVNode(" Skip ")
          ])),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          color: !isDisabledUserMemberPublish.value ? '#000000' : 'rgba(0, 0, 0, 0.2)',
          "text-color": "#ffffff",
          disabled: isDisabledUserMemberPublish.value,
          onClick: _handlePublish
        }, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [
            _createTextVNode(" Publish ")
          ])),
          _: 1
        }, 8, ["color", "disabled"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["complete-personal-information-line", { 'two-complete-personal-information': curCompletePersonalInformationStep.value === 2}])
      }, [
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["weight-line", {'active-line': curCompletePersonalInformationStep.value === item}]),
              key: item
            }, null, 2)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_29, _toDisplayString(curCompletePersonalInformationStep.value) + " of 3 ", 1)
      ], 2)
    ], 512), [
      [_vShow, createAccountStep.value === 4]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_30, [
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "title" }, "Welcome to Charm-Vibe", -1)),
      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "big-logo-cont" }, [
        _createElementVNode("img", { src: _imports_5 })
      ], -1)),
      (createAccountStep.value === 5)
        ? (_openBlock(), _createBlock(_unref(NButton), {
            key: 0,
            color: "#000000",
            "text-color": "#ffffff",
            class: "login-in-done",
            onClick: _handleGoToHomepagePage
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode(" Home ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (createAccountStep.value === 6)
        ? (_openBlock(), _createBlock(_unref(NButton), {
            key: 1,
            color: "#000000",
            "text-color": "#ffffff",
            "icon-placement": "right",
            onClick: _handleGoToMyProfilePage
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode(" Let’s Set Up Your Profile ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, createAccountStep.value === 5 || createAccountStep.value === 6]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_31, [
      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "img-cont" }, [
        _createElementVNode("img", { src: _imports_6 })
      ], -1)),
      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "title" }, "Email verification successful", -1)),
      _createElementVNode("div", _hoisted_32, [
        (registerEmail.value?.email)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(registerEmail.value.email), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("unkown email")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_unref(NButton), {
          color: "#000000",
          "text-color": "#ffffff",
          "icon-placement": "right",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (createAccountStep.value = 3))
        }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createTextVNode(" Continue creating account ")
          ])),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, createAccountStep.value === 7]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_34, [
      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "img-cont" }, [
        _createElementVNode("img", { src: _imports_7 })
      ], -1)),
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "title" }, "Something went wrong", -1)),
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "describe" }, "Sorry, activation failed, please check or contact us!", -1)),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_unref(NButton), {
          color: "#000000",
          "text-color": "#ffffff",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (createAccountStep.value = 1))
        }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [
            _createTextVNode("Return")
          ])),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, createAccountStep.value === 8]
    ]),
    _createVNode(_unref(NModal), {
      show: isShowPrivacyModal.value,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((isShowPrivacyModal).value = $event)),
      "mask-closable": false,
      to: "#app"
    }, {
      default: _withCtx(() => [
        _createVNode(PrivacyPolicyContent, {
          onOnClose: _handleClosePrivacy,
          onOnConfirm: _handleConfirmPrivacy
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NModal), {
      show: isShowTermServiceModal.value,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((isShowTermServiceModal).value = $event)),
      "mask-closable": false,
      to: "#app"
    }, {
      default: _withCtx(() => [
        _createVNode(TermsServiceContent, {
          onOnClose: _handleCloseTermService,
          onOnConfirm: _handleConfirmTermService
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 2))
}
}

})